import { Component } from '@angular/core';

@Component({
  selector: 'app-create-record-layout',
  templateUrl: './create-record-layout.component.html'
})
export class CreateRecordLayoutComponent {}
